var React = require('react');

function RadioTower (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"#3182CE","d":"m226 210c-16.538 0-30 13.462-30 30v90h-30v90l45 30v62h90v-62l45-30v-90l-90-30v-60c0-16.538-13.462-30-30-30z","key":0}),React.createElement("path",{"fill":"#3182CE","d":"m0 329 81.728 1-19.146 38.291 26.836 13.418 25.854-51.709h20.728v-30h30v-60c0-33.091 26.909-60 60-60s60 26.909 60 60v38.379l90 30v20.621h20.466l26.116 52.709 27.836-13.418-19.33-39.291h80.912v-329h-512zm279.027-157.027c-28.271-28.271-77.783-28.271-106.055 0l-21.211-21.211c39.609-39.609 108.867-39.609 148.477 0zm63.648-63.648-21.211 21.211c-52.646-52.617-138.281-52.617-190.928 0l-21.211-21.211c64.336-64.336 169.014-64.336 233.35 0z","key":1})]));
}

RadioTower.defaultProps = {"id":"Capa_1","enableBackground":"new 0 0 512 512","viewBox":"0 0 512 512"};

module.exports = RadioTower;

RadioTower.default = RadioTower;
